<template>
    <v-container>
        <v-layout>
            <v-flex xs4 md3>
                <v-layout mb-3>
                    <v-flex>
                        <v-menu content-class="menu-card mt-2 app-content flex"
                                min-width="450px"
                                transition="scale-transition"
                                :close-on-content-click="false"
                                offset-y
                                full-width
                                v-model="popupFiltro">
                            <v-btn slot="activator" class="btn-default" color="dark" large outline>
                                <v-icon color="primary">lnr-funnel</v-icon>
                                <div class="pl-1">Filtrar</div>
                            </v-btn>
                            <v-layout column class="card">
                                <v-flex mb-4>
                                    <v-text-field ref="textField" v-model="filtro.nome" flat solo hide-details @keyup.enter="filtrar" maxlength="100"></v-text-field>
                                </v-flex>

                                <v-flex>
                                    <v-label>Pontos de venda</v-label>
                                    <autocomplete
                                            placeholder="Selecione os pontos de venda"
                                            v-model="filtro.pontos_venda"
                                            :items="pontos_venda"
                                            item-text="descricao"
                                            item-value="id_ponto_venda"
                                            multiple chips>
                                    </autocomplete>
                                </v-flex>

                                <v-layout mt-3 justify-center>
                                    <v-flex xs4>
                                        <v-btn class="btn-default" color="dark" outline @click="limpar">Limpar</v-btn>
                                    </v-flex>
                                    <v-flex xs4>
                                        <v-btn class="btn-default primary" @click="filtrar">Filtrar</v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-layout>
                        </v-menu>
                    </v-flex>
                    <v-flex>
                        <v-btn class="btn-default" color="primary" large :to="{name:'cadastro_hierarquia'}">
                            Cadastrar
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
        <v-layout column class="card table">
            <data-table ref="table" url="/admin/hierarquias" :filter="dtFiltro" :headers="headers">
                <template slot="items" slot-scope="{ item }">
                    <td width="1%">{{ item.codigo_unidade_negocio }}</td>
                    <td width="1%">{{ item.nome_unidade_negocio }}</td>
                    <td>{{ item.nome_usuario }}</td>
                    <td width="1%">
                        <v-layout>
                            <v-btn flat icon color="primary" @click="editar(item)">
                                <v-icon>ol-edit</v-icon>
                            </v-btn>
                            <v-btn flat icon color="primary" @click="excluir(item)">
                                <v-icon>ol-delete</v-icon>
                            </v-btn>
                        </v-layout>
                    </td>
                </template>
            </data-table>
        </v-layout>
    </v-container>
</template>

<script>
import DataTable from '../components/DataTable'
import { alert, error, sleep } from '../plugins/helpers'

/**
   * @var item
   * @type {object}
   * @property {int} id_ponto_venda
   * @property {string} codigo_unidade_negocio
   * @property {string} nome_unidade_negocio
   * @property {string} nome_usuario
   */

export default {
  components: { DataTable },
  data: () => ({
    headers: [
      { text: 'Código do PV', value: 'codigo_unidade_negocio' },
      { text: 'Nome do Ponto de Venda', value: 'nome_unidade_negocio' },
      { text: 'Diretor', value: 'nome_usuario' },
      { value: '', sortable: false }
    ],
    filtro: {},
    dtFiltro: {},
    popupFiltro: false,
    pontos_venda: []
  }),
  watch: {
    popupFiltro (open) {
      if (open) {
        sleep(100).then(() => this.$refs.textField.focus())
      }
    }
  },
  methods: {
    editar (item) {
      this.$router.push({ name: 'cadastro_hierarquia', params: { id_hierarquia_nivel: `${item.id_hierarquia_nivel}` } })
    },
    excluir (item) {
      alert({
        text: `Tem certeza que deseja remover toda a hierarquia da Unidade de Negócio ${item.codigo_unidade_negocio}(${item.id_ponto_venda}), da diretoria ${item.nome_usuario}?`,
        buttons: {
          'Cancelar': () => true,
          'Excluir': () => {
            this.$http.delete(`/admin/hierarquias/${item.id_hierarquia_nivel}`)
              .then(() => {
                alert(`Hierarquia excluída com sucesso!`)
                this.dtFiltro = { ...this.filtro }
              }).catch(err => {
                error(err, 'Não foi possível excluir a hierarquia.')
              })
          }
        }
      })
    },
    filtrar () {
      this.popupFiltro = false
      this.dtFiltro = { ...this.filtro }
    },
    limpar () {
      this.filtro = { pontos_venda: [] }
      this.filtrar()
    },
    loadUnidadesNegocio () {
      this.$http.get('/admin/unidadesnegocio', {
        params: { pagination: { sortBy: 'codigo' } },
        options: { silent: true }
      }).then((r) => {
        this.pontos_venda = r.data.items.filter(pv => !!pv.nome)
      }).catch(err => {
        error(err, 'Não foi possível recuperar os pontos de venda do filtro.')
      })
    }
  },
  mounted () {
    this.loadUnidadesNegocio()
  }
}
</script>

<style scoped>

</style>
